import {Component, Watch} from 'nuxt-property-decorator';
import AProdPage from "@/classes/page/a-prod-page";
import RoutingUtil from '@/classes/view/routing-util';
import {appModule} from '@/store/app';
import {prodStartModule} from "@/store/prod/start";
import {layoutSelectModule} from '@/store/layout-select';
import {Brands} from '@/configs/brands';
// import {SelectLayouts} from '@/configs/select-layouts';
// import {SelectLayoutsVisual} from '@/configs/select-layouts-visual';

import MoVisualLayout from '@/components/part/official/MoVisualLayout.vue';
import * as $ from 'jquery';
import {bodyModule} from "@/store/body";

@Component({
    layout: 'teaser',
    components: {
        MoVisualLayout,
    }
})
export default class Index extends AProdPage {

    public title: string;

    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-layout';
    public mydivider: string = 'full';

    public state = {
        config: {
            editId: 'officialLayout',
            nextLink: '/wizard-start/welcome',
        },
    };

    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'デザインをえらぶ｜THOUGHT ブランディングツール'
        };
    }

    @Watch('bodyScrollEvent')
    public watchBodyScrollEvent(e: any) {
        console.log('e > ', e.bubbles);
    }

    public get bodyScrollEvent(): any {
        return bodyModule.scrollEvent;
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
        return RoutingUtil.transition(to, from);
    }

    public created() {
        super.created();
    }

    public async mounted() {
        await prodStartModule.load();
        await this.extEdit.updateInput({
            sitename: prodStartModule.input.sitename,
            layout: prodStartModule.input.layout,
        });

        let idx = 0;
        this!['list'].some((_: any) => {
            if (_.pattern_id === this.input.layout.patternId) {
                return true;
            } else {
                idx++;
                return false;
            }
        });

        // console.log('mounted() > init pos > ', idx);
        layoutSelectModule.updateActiveIndex(this.list.length > idx ? idx : 0);
        layoutSelectModule.updateTotal(this.list.length);
    }


    // Computed //////////////////////////////////////////////////////////////
    public get list(): any {

        let _list: any = [];

        // 各Brandから layoutsだけ抽出
        for (let i = 0; i < Brands.length; i++) {
            for (let h = 0; h < Brands[i].layouts.length; h++) {

                _list.push(
                    {
                        brand_id: Brands[i].brandid,
                        layout_id: Brands[i].layouts[h].id,
                        brand_name: Brands[i].name,
                        layout_name: Brands[i].layouts[h].name,
                        brand_comment: Brands[i].comment,
                    }
                );
            }
        }

        return _list;
    }

//     public get list(): any {
//         return SelectLayouts;
//     }

    public get activeIndex(): any {
        return layoutSelectModule.activeIndex;
    }

    public get bg(): any {
        return appModule.pageNavbg;
    }

    public get deviceSize(): any {
        return appModule.deviceSize;
    }


    // Methods ////////////////////////////////////////////////////////////
    /*
        保持するデータ　from /config/select-layouts.ts
        - pattern_id: このレイアウトセレクト自体のID
        - brandid: ブランドID
        - layout: レイアウトID
        - basecolor: 基本カラーパターン
        - sccolor: サイドカバーパターン
        - アップロードされた場合の画像データ
            アップロードされていない場合は、
            img: で指定されている画像を業種選択までの表示として使う。
            その後は、業種選択で選択された場合のダミーデータを表示
    */
    public async selectLayout(): Promise<boolean> {

        const layout = this.list[this.activeIndex];
        // console.log('/official/layout > layout is ', layout);

        await prodStartModule.inputValue({
            layout: {
                patternId: layout.pattern_id,
                brandId: layout.brand_id,
                layout: layout.layout_id,
                basecolor: layout.basecolor,
                sccolor: layout.sccolor,
            }
        });
        // console.log('prodStartModule > ', prodStartModule.input);

        this.$router.push(this.config.nextLink);

        return true;
    }


    // Events /////////////////////////////////////////////////////////////
    public async onInput(e: any) {
        await this.extEdit.onInput(e);
    }

    public async onSelectLayout() {
        await this.selectLayout();
    }

    public async onClickSelectLayout() {
        await this.selectLayout();
    }
}
